import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tip-tap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tip_tap_toolbar = _resolveComponent("tip-tap-toolbar")!
  const _component_editor_content = _resolveComponent("editor-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.hideToolbar && !_ctx.readOnly)
      ? (_openBlock(), _createBlock(_component_tip_tap_toolbar, {
          key: 0,
          editor: _ctx.editor,
          "hide-h3": _ctx.hideH3,
          "hide-h4": _ctx.hideH4,
          "hide-table": _ctx.hideTable,
          "show-align": _ctx.showAlign
        }, null, 8, ["editor", "hide-h3", "hide-h4", "hide-table", "show-align"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_editor_content, { editor: _ctx.editor }, null, 8, ["editor"])
    ])
  ], 64))
}